import { useMutation } from "@tanstack/react-query";

export function useCopyToClipboard() {
  return useMutation({
    mutationFn(text: string) {
      return navigator.clipboard.writeText(text);
    },
  });
}
